import { request } from '@/api/httpClient'
import { ContractType } from '@/enums'

export async function kpiActiveUsers(range) {
  return request({
    method: 'kpi/ActiveUsers',
    payload: {
      Range: Number(range),
      GetTotal: true
    }
  })
}

export async function kpiDashboardQuotes(range) {
  return request({
    method: 'kpi/NumberOfContracts',
    payload: {
      Range: Number(range),
      Type: Number(ContractType.QUOTE)
    }
  })
}

export async function kpiDashboardOrders(range) {
  return request({
    method: 'kpi/NumberOfContracts',
    payload: {
      Range: Number(range),
      Type: Number(ContractType.ORDER)
    }
  })
}

export async function kpiTopCustomersForQuotes(range) {
  return request({
    method: 'kpi/TopCustomersForContracts',
    payload: {
      Range: Number(range),
      Type: Number(ContractType.QUOTE),
      TopN: 8
    }
  })
}

export async function kpiTopCustomersForOrders(range) {
  return request({
    method: 'kpi/TopCustomersForContracts',
    payload: {
      Range: Number(range),
      Type: Number(ContractType.ORDER),
      TopN: 8
    }
  })
}

export async function kpiConversionsFromEnquiriesToQuotes(range) {
  return request({
    method: 'kpi/NumberOfContractConversions',
    payload: {
      Range: Number(range),
      Type: Number(1)
    }
  })
}

export async function kpiConversionsFromQuotesToOrders(range) {
  return request({
    method: 'kpi/NumberOfContractConversions',
    payload: {
      Range: Number(range),
      Type: Number(2)
    }
  })
}
